//imports
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Typography,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import { STOCK_API_02 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import {
  currencyFormat,
  currencyFormatLKR,
  customFormat,
} from "../../../src/utils/common/CurrencyFormat";
const StockDetailsPopup = ({ open, onClose, item }) => {
  //hooks
  const theme = useTheme();
  const styles = useStyles(theme);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [itemDetails, setItemDetails] = useState([]);

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {

    if (item) {
      fetchData();
    }
  }, [item]);

  const fetchData = async () => {
    try {
      const result = await externalgetApi(STOCK_API_02, "get", {
        GRNNO: item.GRNNO,
      });
      setItemDetails(result);
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={styles.popup_title}>Item Details</DialogTitle>
      <DialogContent sx={styles.popup_content}>
        <TableContainer component={Paper}>
          <Table aria-label="item details">
            <TableHead>
              <TableRow>
                <TableCell align="left">Item</TableCell>
                <TableCell align="left">Quantity</TableCell>
                <TableCell align="right">Sell Price</TableCell>
                <TableCell align="center">Expiry</TableCell>
                <TableCell align="right">Tax</TableCell>
                <TableCell align="right">Discount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : error ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <Typography>Error: {error.message}</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                itemDetails.map((detail, index) => (
                  <TableRow key={index}>
                    <TableCell
                      align="left"
                      sx={{
                        maxWidth: "100px",
                        overflow: "hidden", // Hide the overflowed text
                        whiteSpace: "nowrap", // Prevent text from wrapping to the next line
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Tooltip title={detail.MENUNAME} arrow>
                        <span>{detail.MENUNAME}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">{detail.QTY}</TableCell>
                    <TableCell align="right">
                      {currencyFormat(detail.RATE)}
                    </TableCell>
                    <TableCell align="center">{detail.EXPIRY}</TableCell>
                    <TableCell align="right">{currencyFormat(detail.TAXAMT)}</TableCell>
                    <TableCell align="right">{currencyFormat(detail.DISCOUNT)}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{
            background: theme.palette.primary.main,
            color: theme.palette.text.buttontxt,
            textTransform: "capitalize",
            letterSpacing: "1px",
            width: "80px",
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockDetailsPopup;